import React from 'react'
import PropTypes from 'prop-types'

export default function Card({ children, className }) {
  return (
    <div
      className={`light-shadow br3 overflow-hidden relative z-1 bg-base ${className}`}
    >
      {children}
    </div>
  )
}

Card.defaultProps = {
  className: 'mb5 pa5',
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
